import { useEffect } from "react";
import { useStore } from "@/store/store";

type TBreadcrumb = {
  name: string;
  path: string;
};

export const useBreadcrumb = (breadcrumbs: TBreadcrumb[]) => {
  const setBreadCrumbStore = useStore((state) => state.setBreadCrumbStore);

  useEffect(() => {
    setBreadCrumbStore(breadcrumbs);
  }, [breadcrumbs, setBreadCrumbStore]);
};
